var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},[_c('span',{class:`${_vm.baseClass}__circle`}),_c('span',{class:`${_vm.baseClass}__label`},[_vm._v("\n    "+_vm._s(_vm.$epb.messages.instanceManagement.instanceId)+"\n  ")]),_c('span',{class:`${_vm.baseClass}__id`},[_vm._v("\n    "+_vm._s(_vm.instanceId)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }